import { RepertoireActions, RepertoireState, RepertoireActionTypes } from 'Types/RepertoireTypes';

export interface RepertoireReducer {
  repertoireReducer: RepertoireState;
}

export const defaultState: RepertoireState = {
  repertoireData: [],
  userRepertoireProgresses: [],
  userRepertoireData: [],
  repertoireIdSelect: 1,
  repertoirePlaying: false,
  repertoireEnded: false,
  cursorVisible: true,
  playSessionId: null,
  verticalScrollPositions: { home: 0, browse: 0 },
  horizontalScrollPositions: {},
};

export const repertoireReducer = (
  state = defaultState,
  action: RepertoireActions,
): RepertoireState => {
  switch (action.type) {
    case RepertoireActionTypes.SET_CURSOR_VISIBLE:
      return {
        ...state,
        cursorVisible: action.payload,
      };

    case RepertoireActionTypes.LOAD_REPERTOIRE_STATE:
      return {
        ...state,
        ...action.payload,
      };

    case RepertoireActionTypes.FETCH_REPERTOIRE_DATA_SUCCESS:
      return {
        ...state,
        repertoireData: action.payload,
      };

    case RepertoireActionTypes.SET_REPERTOIRE_ENDED:
      return {
        ...state,
        repertoireEnded: action.payload,
      };

    case RepertoireActionTypes.SET_REPERTOIRE_SELECT:
      return {
        ...state,
        repertoireIdSelect: action.payload.repertoireIdSelect,
        // currentUserLevelData: find(state.userLevelData, uld => uld.level.level_number === state.levelData[action.payload.levelSelect].level_number),
        // currentLevelTiers: find(state.tiersByLevels, tbl => tbl.level_number === state.levelData[action.payload.levelSelect].level_number)?.tiers
      };

    case RepertoireActionTypes.FETCH_URP_SUCCESS: {
      const current_urp = state.userRepertoireProgresses;
      const updatedArray = current_urp.slice();
      // This is used to "merge" the single-value array that gets passed with the put
      action.payload.forEach((payload_urp) => {
        const index = updatedArray.findIndex((state_urp) => state_urp.id === payload_urp.id);
        if (index !== -1) {
          updatedArray[index] = payload_urp;
        } else {
          updatedArray.push(payload_urp);
        }
      });

      return {
        ...state,
        userRepertoireProgresses: updatedArray,
      };
    }
    case RepertoireActionTypes.SET_REPERTOIRE_PLAYING:
      return {
        ...state,
        repertoirePlaying: action.payload.repertoirePlaying,
      };

    case RepertoireActionTypes.SET_PLAY_SESSION_ID:
      return {
        ...state,
        playSessionId: action.payload,
      };

    case RepertoireActionTypes.UPDATE_REPERTOIRE_DATA_LOCAL: {
      const urp = state.userRepertoireProgresses;
      if (urp) {
        const updatedArr = urp.slice();
        // This is used to "merge" the single-value array that gets passed with the put
        const payload_urp = action.payload;
        const index = updatedArr.findIndex((state_urp) => state_urp.id === payload_urp.id);
        if (index !== -1) {
          updatedArr[index] = { ...updatedArr[index], last_tempo: payload_urp.last_tempo };
        }
        return {
          ...state,
          userRepertoireProgresses: updatedArr,
        };
      } else {
        return state;
      }
    }

    case RepertoireActionTypes.CREATE_REPERTOIRE_SESSION:
      return state;

    case RepertoireActionTypes.FETCH_USER_REPERTOIRE_SUCCESS:
      return {
        ...state,
        userRepertoireData: action.payload,
      };

    case RepertoireActionTypes.SET_USER_REPERTOIRE_PROCESSING: {
      const updatedUserRepertoire = state.userRepertoireData.map((rep) =>
        rep.id === action.payload.id ? { ...rep, status: action.payload.status } : rep,
      );
      return {
        ...state,
        userRepertoireData: updatedUserRepertoire,
      };
    }

    case RepertoireActionTypes.SET_VERTICAL_SCROLL:
      return {
        ...state,
        verticalScrollPositions: {
          ...state.verticalScrollPositions,
          [action.payload.page]: action.payload.position,
        },
      };

    case RepertoireActionTypes.SET_HORIZONTAL_SCROLL:
      return {
        ...state,
        horizontalScrollPositions: {
          ...state.horizontalScrollPositions,
          [action.payload.rowId]: action.payload.position,
        },
      };

    default:
      return state;
  }
};
